import { render, staticRenderFns } from "./distributionGoodsItem.vue?vue&type=template&id=78bf24e9&scoped=true&"
import script from "./distributionGoodsItem.vue?vue&type=script&lang=js&"
export * from "./distributionGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./distributionGoodsItem.vue?vue&type=style&index=0&id=78bf24e9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf24e9",
  null
  
)

export default component.exports